import { FooterBrand, FooterLegalLinks, FooterContact } from "./FooterSections";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 px-5 pb-10 pt-20 md:px-10">
    <div className="mx-auto max-w-7xl">
      <div data-testid="footer-brand-wordmark" className="font-head text-[16vw] font-black leading-none tracking-tighter text-white/5 xl:text-[12rem]">WebEssence</div>
      <div className="mt-10 grid grid-cols-1 gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
        <FooterBrand />
        <FooterLegalLinks />
        <FooterContact />
      </div>
      <div data-testid="footer-copyright" className="mt-10 border-t border-white/10 pt-6 text-sm text-zinc-500">WebEssence © 2026</div>
    </div>
  </footer>
);